import React from "react";
import './Loader.scss'
import Lottie from "react-lottie";
import animationData from "../../Assets/98510-loader.json";

interface Props {
    visible: boolean
}

const Loader: React.FC<Props> = ({visible}: Props) => {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <>
            {
                visible && (
                    <div className="loader">
                        <Lottie
                            options={defaultOptions}
                            height={400}
                            width={400}
                        />
                    </div>
                )
            }
        </>
    )
}

export default Loader
